import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function ny(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const convertFormData = (formData: FormData): Record<string, string | File> => {
    const submitData: Record<string, string | File> = {};

    formData.forEach((value, key) => {
        submitData[key] = value instanceof File ? value : String(value);
    });

    return submitData;
};

export const toShuffle = <T>(array: T[]) => {
    const shuffledArray = [...array];

    function shuffleArray<T>(array: T[]): T[] {
        let currentIndex = array.length;
        while (currentIndex != 0) {
            const randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    }

    const chunkSize = Math.floor(shuffledArray.length / 3);

    const firstRow = shuffleArray(shuffledArray.slice(0, chunkSize));
    const secondRow = shuffleArray(shuffledArray.slice(chunkSize, chunkSize * 2));
    const thirdRow = shuffleArray(shuffledArray.slice(chunkSize * 2));

    return shuffleArray([...firstRow, ...secondRow, ...thirdRow]);
};
